import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@vsat/shared/lib/utils';
import { Card } from '@vsat/shared/components';
import { Label } from '@vsat/shared/components';
import { Input } from '@vsat/shared/components';

interface FillBlankQuestionProps {
  value?: string;
  onChange: (value: string) => void;
  readOnly?: boolean;
  placeholder?: string;
  className?: string;
}

const FillBlankQuestion: React.FC<FillBlankQuestionProps> = ({
  value = '',
  onChange,
  readOnly = false,
  placeholder,
  className,
}) => {
  const { t } = useTranslation();
  const inputRef = React.useRef<HTMLInputElement>(null);

  // Focus input when component mounts
  React.useEffect(() => {
    if (inputRef.current && !readOnly) {
      inputRef.current.focus();
    }
  }, [readOnly]);

  return (
    <Card
      className={cn(
        'p-4 bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-xl border border-border shadow-sm',
        className
      )}
    >
      <div className='space-y-3'>
        {/* Input Field */}
        <div className='space-y-2'>
          <Label htmlFor='fill-blank-input' className='text-sm font-medium text-foreground'>
            {t('landing.questions.yourAnswer')}
          </Label>
          <Input
            ref={inputRef}
            id='fill-blank-input'
            type='text'
            value={value}
            onChange={e => onChange(e.target.value)}
            disabled={readOnly}
            placeholder={placeholder || t('landing.questions.placeholder.enterAnswer')}
            className={cn(
              'w-full p-3 text-base',
              'border-border bg-card',
              'focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary',
              'hover:border-primary dark:hover:border-primary',
              readOnly && 'opacity-50 cursor-not-allowed'
            )}
          />
        </div>
      </div>
    </Card>
  );
};

export default FillBlankQuestion;
